import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    loading: false, //  全局loading
    userInfo: {},
    echartsColor: [
      '#5F8EEC',
      '#69D4AA',
      '#FFD995',
      '#FF8484',
      '#7384FF',
      '#8478FF',
      '#51D2D0',
      '#CF70FF',
      '#EA67A5',
      '#EC8E5F',
      '#EB7171',
      '#8DEEAF',
      '#FFE2AB',
      '#93A3FF',
      '#FF6D6D',
      '#95B8FF',
      '#64D2FF',
      '#C7A5FF',
      '#FF95D9',
      '#F7E58A',
      '#ECBB5F',
      '#FFEBA8'
    ],
    subjectName: null,
    currentSubject: {},
    querys: {},
    examIsActive: 1, //学情列表默认选中Tab
    unionReport: false //报表默认数据开关
  },
  mutations: {
    setUnionReport(state, bol) {
      state.unionReport = bol
    },
    setLoading(state, bol) {
      state.loading = bol
    },
    setuserInfo(state, bol) {
      state.userInfo = bol
    },
    setsubjectName(state, bol) {
      state.subjectName = bol
    },
    setcurrentSubject(state, bol) {
      state.currentSubject = bol
    },
    setQuerys(state, val) {
      state.querys = val
    }
  },
  actions: {},
  modules: {},
  plugins: [createPersistedState()]
})
